import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../api/client';

export default function DigitalInvitationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.getDigitalInvitations();
      setItems(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id) => {
    if (!window.confirm('Bu dijital davetiyeyi silmek istediğinize emin misiniz?')) return;
    try {
      await api.deleteDigitalInvitation(id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <header className="admin-header">
        <h2>Dijital Davetiyeler</h2>
        <p>QR kodlu online davetiyelerinizi oluşturun ve yönetin</p>
      </header>

      <div className="admin-content">
        {error && <div className="admin-alert admin-alert--error">{error}</div>}

        <div className="admin-page-actions">
          <h3>Tüm davetiyeler ({items.length})</h3>
          <Link to="/admin/digital-invitations/new" className="admin-btn admin-btn--primary">
            + Yeni dijital davetiye
          </Link>
        </div>

        <div className="admin-table-wrap">
          {loading ? (
            <div className="admin-empty">Yükleniyor…</div>
          ) : items.length === 0 ? (
            <div className="admin-empty">Henüz dijital davetiye yok</div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Başlık</th>
                  <th>Slug / Link</th>
                  <th>Durum</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.landing?.title || item.couple?.bride + ' & ' + item.couple?.groom}</td>
                    <td>
                      <code>/{item.slug}</code>
                      {item.published && (
                        <div>
                          <a href={`/${item.slug}`} target="_blank" rel="noreferrer" style={{ fontSize: '0.75rem' }}>
                            Görüntüle ↗
                          </a>
                        </div>
                      )}
                    </td>
                    <td>
                      <span className={`admin-badge ${item.published ? 'admin-badge--ok' : 'admin-badge--muted'}`}>
                        {item.published ? 'Yayında' : 'Taslak'}
                      </span>
                    </td>
                    <td>
                      <div className="admin-table__actions">
                        <Link to={`/admin/digital-invitations/${item.id}/edit`} className="admin-btn admin-btn--secondary admin-btn--sm">
                          Düzenle
                        </Link>
                        <button type="button" className="admin-btn admin-btn--danger admin-btn--sm" onClick={() => handleDelete(item.id)}>
                          Sil
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
